<template>
	<el-row class="w100 yl-header pf">
		<el-row class="bg w100" :style="{opacity:headOpacity,background:$route.meta.background}"></el-row>
		<el-row class="yl-warp single">
			<a class="fl" :href="$config.server['root'].url"><img :src="$config.server['static'].address+$config.server['static'].name+'/i/public/logo.png'" alt="中企云链" /></a>
			<h3 class="ft22 fl white" style="font-size:22px">{{title}}</h3>
		</el-row>
	</el-row>
</template>
<script>
export default{
	props:["opacity","title","projectName"],
	computed:{
		
	},
	data() {
		return {
			rootUrl:this.$config.server['root'].url,
			headOpacity:'',
		}
	},
	mounted(){
		window.addEventListener('scroll', this.windowScroll)
	},
	beforeDestroy() {
      	window.removeEventListener('scroll', this.windowScroll)
	},
	created(){
		this.headOpacity=this.opacity;
	},
	methods:{
		windowScroll() {
			// 滚动条距离页面顶部的距离
			// 以下写法原生兼容
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if(this.$route.meta.title=="云投" || this.$route.meta.title=="政采信"){
				if(scrollTop<=60){
					this.headOpacity="0";
					this.$route.meta.headerOpacity=this.headOpacity;
					this.$route.meta.background="none";
				}else{
					this.headOpacity="1";
					this.$route.meta.headerOpacity=this.headOpacity;
					this.$route.meta.background="#0652f7";
				}
			}
		}
	},
}
</script>